/* eslint-disable react-hooks/exhaustive-deps */
import React, { useLayoutEffect, useState } from "react";
import { PlusOutlined } from "@ant-design/icons";
import { getAPI } from "../../utils/common";
import LayoutHeader from "../inc/LayoutHeader";
import LayoutFooter from "../inc/LayoutFooter";
import {
  Space,
  Button,
  Card,
  Layout,
  Table,
  Tag,
  Input,
  Modal,
  List,
  Form,
  Select,
} from "antd";
import { ALL_BOOKING, ALL_ORDER } from "../../constants/api";
import { useNavigate } from "react-router-dom";

function OrderTable() {
  const { Content } = Layout;
  const navigate = useNavigate();

  const [state, setState] = useState([]);
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState([]);

  // Modal states
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [isBookingModalVisible, setIsBookingModalVisible] = useState(false);

  useLayoutEffect(() => {
    getBookings();
    getData();
  }, []);

  const getBookings = () => {
    setLoading(true);

    const successFn = (data) => {
      setLoading(false);
      if (data.status === true) {
        const booking_data = data["data"]
          .filter((row) => row.booking_status === "1")
          .map((row) => ({
            value: row.id,
            label: row.room_no,
          }));
        setBookings(booking_data);
      } else {
        setBookings([]);
      }
    };

    const errorFn = () => {
      setBookings([]);
      setLoading(false);
    };

    getAPI(ALL_BOOKING + "active", successFn, errorFn, {});
  };

  const getData = () => {
    setLoading(true);
    const successFn = function (data) {
      if (data.status === true) {
        const roomData = data["data"].map((row, index) => ({
          key: index,
          ID: index + 1,
          order_id: row.booking.order_id,
          booking_id: row.booking.id,
          room_no: row.booking.room_no,
          c_name: row.booking.user.name,
          c_phone: row.booking.user.phone,
          total_items: row.items.length,
          bill_amt: row.total,
          pay_method: row.paymentMethod,
          pay_status: row.o_tnx.status,
          room_no_tag: <Tag color="green">{row.booking.room_no}</Tag>,
          pay_status_tag: (
            <Tag color={row.o_tnx.status === "Successful" ? "green" : "red"}>
              {row.o_tnx.status}
            </Tag>
          ),
          Action: (
            <Space>
              <Button
                loading={loading}
                disabled={loading}
                onClick={() => openItemsModal(row.items)}
                danger
              >
                Items
              </Button>
            </Space>
          ),
        }));
        setState(roomData);
        setFilteredData(roomData);
        setLoading(false);
      } else {
        setState([]);
        setFilteredData([]);
        setLoading(false);
      }
    };
    const errorFn = function () {
      setState([]);
      setFilteredData([]);
      setLoading(false);
    };
    getAPI(ALL_ORDER, successFn, errorFn, {});
  };

  const handleSearch = (value) => {
    setSearchText(value);
    const filtered = state.filter(
      (room) =>
        room.order_id.includes(value) ||
        room.pay_status
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()) ||
        room.room_no.includes(value) ||
        room.c_name.toString().toLowerCase().includes(value.toLowerCase()) ||
        room.c_phone.toString().includes(value)
    );
    setFilteredData(filtered);
  };

  const openItemsModal = (items) => {
    setSelectedItems(items);
    setIsModalVisible(true);
  };

  const handleModalClose = () => {
    setIsModalVisible(false);
    setSelectedItems([]);
  };

  const openBookingModal = () => {
    setIsBookingModalVisible(true);
  };

  const columns = [
    {
      title: "Sno",
      dataIndex: "ID",
      width: 50,
    },
    {
      title: "Room No",
      dataIndex: "room_no_tag",
      width: 50,
    },
    {
      title: "Booking ID",
      dataIndex: "booking_id",
      width: 50,
    },
    {
      title: "Customer",
      dataIndex: "c_name",
      width: 100,
    },
    {
      title: "Items",
      dataIndex: "total_items",
      width: 50,
    },
    {
      title: "Total Amount",
      dataIndex: "bill_amt",
      width: 50,
    },
    {
      title: "Pay Method",
      dataIndex: "pay_method",
      width: 100,
    },
    {
      title: "Payment Status",
      dataIndex: "pay_status_tag",
      width: 50,
    },
    {
      title: "Action",
      dataIndex: "Action",
      width: 100,
    },
  ];

  return (
    <>
      <Layout>
        <LayoutHeader />
        <Content>
          <Card
            title="Manage Orders"
            extra={
              <Space>
                <Input
                  placeholder="Search by Name or Room No"
                  value={searchText}
                  onChange={(e) => handleSearch(e.target.value)}
                  style={{ width: 300 }}
                />
                <Button onClick={openBookingModal}>
                  New Order <PlusOutlined />
                </Button>
              </Space>
            }
            bordered={true}
          >
            <Table
              loading={loading}
              columns={columns}
              dataSource={filteredData}
              pagination={{ pageSize: 10 }}
              scroll={{ x: 240 }}
            />
          </Card>

          {/* Modal for displaying order items */}
          <Modal
            title="Order Items"
            visible={isModalVisible}
            onCancel={handleModalClose}
            footer={null}
            width={600}
          >
            <List
              dataSource={selectedItems}
              renderItem={(item, index) => (
                <List.Item key={index}>
                  <List.Item.Meta
                    title={`Product: ${item.product_name}`}
                    description={
                      <>
                        <p>Quantity: {item.quantity}</p>
                        <p>Price: {item.product_amt}</p>
                        <p>Total: {item.total_amt}</p>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: item.product_description,
                          }}
                        />
                      </>
                    }
                  />
                </List.Item>
              )}
            />
          </Modal>

          {/* Modal for selecting booking */}
          <Modal
            title="Select Booking"
            visible={isBookingModalVisible}
            onCancel={() => setIsBookingModalVisible(false)}
          >
            <Form.Item
              layout="vertical"
              name="booking_id"
              label="Booking"
              rules={[
                {
                  required: true,
                  message: "Booking is required!",
                },
              ]}
            >
              <Select
                showSearch
                allowClear
                placeholder="Select a Booking"
                optionFilterProp="label"
                options={bookings}
                onChange={(e) => navigate("/order/product/" + e)}
              />
            </Form.Item>
          </Modal>
        </Content>
        <LayoutFooter />
      </Layout>
    </>
  );
}

export default OrderTable;
